module.exports = __webpack_public_path__ + "img/Proliferation-OVCA_10X_TIP.ab32264a.png";